import { Person } from '@src/api/@types/GetPersonDTO'

export function formatDateLanguage(dateString: string | undefined | null, locale?: string): string {
  if (!dateString || dateString === 'undefined') {
    return 'Date not Available'
  }

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  }

  const date = new Date(dateString.replace(' ', 'T'))
  const formattedDate = new Intl.DateTimeFormat(locale, options).format(date)
  return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1)
}

export const formatAmount = (amount: number) => {
  const [dollars, cents] = amount.toFixed(2).split('.')
  return { dollars, cents }
}

export const formatDays = (dateString: string | undefined | null, locale?: string): string => {
  if (!dateString) return ''
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  }
  const date = new Date(dateString.replace(' ', 'T'))
  const formattedDate = new Intl.DateTimeFormat(locale, options).format(date)
  return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1)
}

export const DateFormat = (dateString: string, locale?: string) => {
  const date = new Date(dateString)
  return new Intl.DateTimeFormat(locale, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(date)
}

export const formatDateWithoutDay = (dateString: string, locale?: string) => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat(locale, { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  }).format(date);
}

export const getDaysToNextPayment = (nextPaymentDateUTC: string) => {
  const today = new Date()
  const nextPaymentDate = new Date(nextPaymentDateUTC)
  const timeDifference = nextPaymentDate.getTime() - today.getTime()
  return Math.ceil(timeDifference / (1000 * 3600 * 24))
}

export const formatAddress = (data: Person): string => {
  const { addresseNo, addresseStreet, addresseCity, addresseStateISO, addressePostalCode, addresseCountry } = data
  return `${addresseNo} ${addresseStreet}, ${addresseCity}, ${addresseStateISO}, ${addressePostalCode}, ${addresseCountry}`
}

export const handleAmountChange = (dollarAmount: string, centAmount: string) => {
  const total = parseFloat(`${dollarAmount}.${centAmount}`).toFixed(2)
  return total
}

export const capitalizeFirstLetter = (string: string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export const capitalizeFirstLetterOnly = (str: string): string => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}